import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { PERSIST_QUICK_ADD_ON_SEARCH_TILE_241029 } from "@faire/web-api--source/indigofair/settings/PERSIST_QUICK_ADD_ON_SEARCH_TILE_241029";
export var useSettingPersistQuickAddOnSearchTile = function() {
    return useSetting(PERSIST_QUICK_ADD_ON_SEARCH_TILE_241029, false);
};
export var useAssignSettingPersistQuickAddOnSearchTile = function() {
    return useAssignSetting(PERSIST_QUICK_ADD_ON_SEARCH_TILE_241029);
};
